import { render, staticRenderFns } from "./ModalHelp.vue?vue&type=template&id=3b2538e4&scoped=true"
import script from "./ModalHelp.vue?vue&type=script&lang=js"
export * from "./ModalHelp.vue?vue&type=script&lang=js"
import style0 from "./ModalHelp.vue?vue&type=style&index=0&id=3b2538e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2538e4",
  null
  
)

export default component.exports